import { IAppAction, ActionType } from './../actions/Helpers';
import { User } from '../state/user.state';

export const AuthenticationReducer = (state: User = null, action: IAppAction): User => {
    switch (action.type) {
        case ActionType.LOGIN_REQUEST:
            const authConfigs = {
                cognitoUserId: action.payload.signInUserSession.idToken.payload.sub,
                refreshToken: action.payload.signInUserSession.refreshToken.token,
                accessToken: action.payload.signInUserSession.accessToken.jwtToken,
            };
            return {
                ...state,
                authConfigs,
                username: action.payload.username,
            };
        case ActionType.FETCH_USER_DETAILS:
            return {
                ...state,
                firstName: action.payload.first_name || null,
                lastName: action.payload.last_name || null,
                menus: action.payload.menus || null,
                abilities: action.payload.abilities || [],
                isOrganisation: action.payload.organisation_id ? true : false,
                organisation_name: action.payload.organisation_name || null,
                id: action.payload.id || null,
                phone_no: action.payload.phone_no || null,
                email: action.payload.email || null,
                organisation_id: action.payload.organisation_id || null,
                terms_and_condition_required: action.payload.terms_and_condition_required,
                has_saved_terms: action.payload.has_saved_terms,
                copyright_text_admin: action.payload.copyright_text_admin || null,
                version_number_admin: action.payload.version_number_admin || null,
            };
        case ActionType.USER_DATA:
            const configData = {
                cognitoUserId: action.payload.signInUserSession.idToken.payload.sub,
                refreshToken: action.payload.signInUserSession.refreshToken.token,
                accessToken: action.payload.signInUserSession.accessToken.jwtToken,
            };
            return {
                ...state,
                authConfigs: configData,
                username: action.payload.username,
                firstName: action.payload.first_name || null,
                lastName: action.payload.last_name || null,
                menus: action.payload.menus || null,
                abilities: action.payload.abilities || [],
                isOrganisation: action.payload.organisation_id ? true : false,
                organisation_name: action.payload.organisation_name || null,
                id: action.payload.id || null,
                phone_no: action.payload.phone_no || null,
                email: action.payload.email || null,
                organisation_id: action.payload.organisation_id || null,
                terms_and_condition_required: action.payload.terms_and_condition_required,
                has_saved_terms: action.payload.has_saved_terms,
                copyright_text_admin: action.payload.copyright_text_admin || null,
                version_number_admin: action.payload.version_number_admin || null,
            };
        case ActionType.LOGOUT_REQUEST:
            return null;
        case ActionType.CHANGE_LANGUAGE:
            return {
                ...state,
                language: action.payload,
            };
        default:
            return state;
    }
};
